
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sveitarfelog/stodumat",
      function () {
        return require("private-next-pages/sveitarfelog/stodumat.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sveitarfelog/stodumat"])
      });
    }
  